import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import CustomerModal from "../components/CustomerModal";
import "./home.css";
import ShowDate from "../components/ShowDate";
import { API } from "../configs/urlConfig";
import Utils from "../utils";

function Home() {
  const navigate = useNavigate();

  const [showModal, setShowModal] = useState(false);
  const [showModalDatum, setShowModalDatum] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);
  const downloadDatabase = async () => {
    try {
      setIsDownloading(true);
      const response = await fetch(`${API}/api/download_database/`, {
        method: "GET",
        ...Utils.getUserToken(),
      });

      if (!response.ok) {
        throw new Error("Greška prilikom preuzimanja baze.");
      }

      // Pretvaranje u blob
      const blob = await response.blob();

      // Kreiranje URL-a
      const url = window.URL.createObjectURL(blob);

      // Kreiranje <a> taga
      const a = document.createElement("a");
      a.href = url;
      // Ime fajla
      // Format: YYYYMMDD_HHMMSS
      const now = new Date();

      const pad = (num) => String(num).padStart(2, "0");

      const timestamp =
        now.getFullYear() +
        pad(now.getMonth() + 1) +
        pad(now.getDate()) +
        "_" +
        pad(now.getHours()) +
        pad(now.getMinutes()) +
        pad(now.getSeconds());
      a.download = `db_${timestamp}.sqlite3`;

      document.body.appendChild(a);
      a.click();

      // Čišćenje
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error(error);
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <>
      <div className="home-container">
        <div className="overlay">
          <button
            style={{ position: "absolute", top: "10px", right: "10px" }}
            className="custom-btn btn-all-date"
            onClick={downloadDatabase}
            disabled={isDownloading}
          >
            {isDownloading ? "⏳" : "⬇️"}
          </button>
        </div>

        <div className="content text-center">
          {/* <h1 className="title mb-5">Dobrodošli</h1> */}

          <div className="d-grid gap-4 col-10 col-sm-8 col-md-5 mx-auto">
            {/* DATUM BUTTON */}
            <button
              className="custom-btn btn-all-date"
              onClick={() => navigate("/by-date-all")}
            >
              📅 SVE
            </button>

            <button
              className="custom-btn btn-date"
              onClick={() => setShowModalDatum(true)}
            >
              📅
            </button>

            <button
              className="custom-btn btn-clients"
              onClick={() => navigate("/users")}
            >
              👥
            </button>

            <button
              className="custom-btn btn-logout"
              onClick={() => {
                localStorage.removeItem("jwt");
                navigate("/login");
              }}
            >
              🚪
            </button>
          </div>
        </div>
        <ShowDate
          showModalDatum={showModalDatum}
          setShowModalDatum={setShowModalDatum}
        />
        {/* MODAL */}

        {/* BACKDROP */}
        {showModal && (
          <div className="backdrop" onClick={() => setShowModal(false)}></div>
        )}
      </div>
      {/* <section className="content-panel mt-1">
        <div
          ref={containerRef}
          className="row g-3"
          style={{ maxHeight: "90vh", overflowY: "auto" }}
        >
          {date_arr.map((dayData, index) => (
            <div
              key={index}
              className={`shadow-sm  border-0 d-flex align-items-center justify-content-center ${index === getTodayIndex() ? "text-white bg-primary bg-opacity-50" : index.toString() === todayIndex ? "bg-secondary bg-opacity-25" : ""}`}
              style={{ cursor: "pointer", height: "50px", margin: "0px" }}
              onClick={() => goToDate(dayData)} // <-- klik handler
            >
              <h5 className="fw-semibold text-center mb-0">{dayData}</h5>
            </div>
          ))}
        </div>
      </section> */}
      {/* <div
        className="d-flex justify-content-between align-items-center w-100"
        style={{
          position: "fixed",
          left: 0,
          bottom: 0,
          backgroundColor: "white",
          padding: "10px",
        }}
      >
        <button
          type="button"
          className="btn btn-outline-danger  btn-sm desktop-add-btn"
          onClick={() => {
            localStorage.removeItem("jwt");
            navigate("/login");
          }}
        >
          Logout
        </button>
        <button
          type="button"
          className="btn btn-primary btn-sm desktop-add-btn"
          onClick={() => navigate("/users")}
        >
          Mušterije
        </button>
        <button
          type="button"
          className="btn btn-primary btn-sm desktop-add-btn"
          onClick={() => {
            const todayIdx = getTodayIndex();
            const orta = Math.floor(containerRef?.current?.clientHeight / 100);
            containerRef.current.scrollTo({
              top: (todayIdx - orta) * ITEM_HEIGHT,
              behavior: "smooth",
            });
            seToDayIndex(todayIdx);
            localStorage.setItem("todayIndex", todayIdx);
          }}
        >
          Danas
        </button>
      </div> */}
      {showModal && (
        <CustomerModal
          onClose={() => setShowModal(false)}
          onSave={(customer) => console.log("Nova mušterija:", customer)}
        />
      )}
    </>
  );
}

export default Home;
